export default "__VITE_ASSET__BaECFbIU__"